<template>
  <div class="layer pa-4 builder-loading" role="status" aria-live="polite">
    <v-row class="flex-column fill-height" align="center" justify="center" no-gutters>

      <Spinner/>
      <span>Preparing your bike…</span>

    </v-row>
  </div>
</template>

<script>

  import Spinner from '@/components/Spinner';

  export default {
    components: {
      Spinner
    }
  }
</script>

<style scoped>
.builder-loading { background:#f6f5f1; color:#252c22; }
.builder-loading span { font-size:13px; letter-spacing:.04em; }
</style>
